import { styled } from '@/src/stitches.config'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import handleEnterPressEvent from '@/src/common/utilities/handleEnterPressEvent'

export const Container = styled('div', {
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'scroll',
})

export const DeliveryList = styled('div', {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    '@md': {
        flexDirection: 'row',
    },
    variants: {
        border: {
            bottom: {
                borderBottom: '2px solid $mediumGray',
            },
        },
    },
})

export const OrderTotalRow = styled('div', {
    display: 'flex',
    jc: 'space-between',
    pt: 10,
    margin: '12px',
    borderBottom: '1px solid $mediumGray',
    '@md': {
        pt: 50,
        mb: 20,
    },
    '& p': {
        fontSize: '1.4rem',
        fontWeight: 'bold',
        color: '$primary',
    },
    '& h4': {
        fontSize: '1.4rem',
        fontWeight: 'bold',
    },
})

export const ShippingTitle = ({ text = 'Shipping' }: { text?: string }) => {
    return <h2 style={{ marginTop: '8px', fontSize: '24px' }}>{text}</h2>
}

export const OrderTotal = ({ total }: { total?: string | number }) => {
    if (!total) {
        return <></>
    }

    return (
        <OrderTotalRow>
            <h4>Order Total</h4>
            <p>${total}</p>
        </OrderTotalRow>
    )
}

export const ShippingFormContainer = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
    maxWidth: 500,
})

const BackButtonStyles = styled('div', {
    display: 'inline-block',
    cursor: 'pointer',
    margin: '16px 0',
    '&:hover': {
        color: '$primary',
        textDecoration: 'underline',
    },
})

export const BlueLink = styled('a', {
    cursor: 'pointer',
    color: '$secondary',
    textDecoration: 'underline',
})

export const BackButton = ({
    onClick,
    backText = 'Back',
}: {
    onClick?: Function
    backText?: string
}) => {
    function backEvent() {
        onClick ? onClick() : history.back()
    }

    return (
        <BackButtonStyles
            tabIndex={0}
            onClick={() => backEvent()}
            onKeyDown={(e) => handleEnterPressEvent(e, () => backEvent())}
        >
            <FontAwesomeIcon
                icon={faArrowLeft}
                style={{ marginRight: '0.5rem' }}
            />
            &nbsp;{backText}
        </BackButtonStyles>
    )
}

export const MultiShipmentActionText = ({
    multiple,
    onClick,
}: {
    multiple: boolean
    onClick: Function
}) => {
    const actionText = multiple
        ? {
              label: 'Each physical gift card ships to a different address.',
              cta: 'Want to ship to the same address?',
          }
        : {
              label: 'Applies to all physical gifts in the cart.',
              cta: 'Want to ship to multiple addresses?',
          }

    return (
        <p style={{ maxWidth: '500px' }}>
            {actionText.label}{' '}
            <BlueLink
                onClick={() => onClick()}
                onKeyDown={(e) => handleEnterPressEvent(e, () => onClick())}
                tabIndex={0}
            >
                {actionText.cta}
            </BlueLink>
        </p>
    )
}
